module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter",
    attrs: {
      "id": "AVFi"
    }
  }, [_c('section', {
    staticClass: "chapter",
    attrs: {
      "epub:type": "chapter",
      "id": "section_level_h1_01",
      "role": "doc-chapter",
      "title": "JANUARY 10: New Life"
    }
  }, [_c('h1', {
    staticClass: "chapter2",
    attrs: {
      "id": "pACEI"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/contents#AB_ch11",
      "id": "AB_cha11"
    }
  }, [_vm._v("JANUARY 10"), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "chapter2a"
  }, [_vm._v("New Life")])])]), _vm._v(" "), _c('blockquote', [_c('p', {
    staticClass: "ext",
    attrs: {
      "id": "pARU"
    }
  }, [_c('em', [_vm._v("Anyone who belongs to Christ is a new person. The past is forgotten, and everything is new.")])])]), _vm._v(" "), _c('p', {
    staticClass: "right",
    attrs: {
      "id": "pAdZZ"
    }
  }, [_vm._v("—2 Corinthians 5:17 "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("CEV")])]), _vm._v(" "), _c('p', {
    staticClass: "noind",
    attrs: {
      "id": "ACt7"
    }
  }, [_c('span', {
    staticClass: "dcap"
  }, [_c('b', [_vm._v("E")])]), _vm._v("ach season has its own unique sort of beauty. Spring offers warmer days and bright, blooming flowers. Summer is lush with green and alive with birds and animals. Fall shines with its rich colors of gold and red and russet. And winter . . . yes, it has its beauty with glimmering snowfalls and crystal-clear days. Yet so much of winter seems cold and even lifeless. Trees bared of their leaves stretch bony fingers up to the sky, seeking the rare rays of the winter sun’s warmth.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "pAci0"
    }
  }, [_vm._v("But as you gaze out your window, consider those trees from another perspective: those trees with their bare branches are actually a beautiful promise from God. They remind us that winter doesn’t last forever, that spring is not only coming but is, in fact, actively on its way. Deep inside the hearts of those winter trees, new life is stirring, and before too long it will bloom forth.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "pAfcp"
    }
  }, [_vm._v("There are days when you may feel a bit like those cold trees of winter. When you do, reach up to God, who is never stingy with the warmth of His love. Let Him stir new life within you during this winter season, and watch Him make you bloom in beauty.")]), _vm._v(" "), _c('p', {
    staticClass: "left1",
    attrs: {
      "id": "pAEQ"
    }
  }, [_c('em', [_vm._v("Lord, when the days are cold, thank You for the warmth of Your love and the new life in Christ You have given to me.")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b60c1872","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chapter11.vue
// module id = 99
// module chunks = 0